<template>
  <div>
    <div>{{day}}</div>
    <div style="font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;">{{month}}</div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    date: {
      type: String,
      required: true
    }, 
    format: {
      type: String
    }
  },
  computed: {
    day() {

      return moment(this.date, this.format)
        .locale("es_ve")
        .format("DD");
    },
    month() {
      return moment(this.date, this.format)
        .locale("es_ve")
        .format("MMM");
    }
  }
};
</script>
